import AppLayout from "Layout/Layout";
import { NonIndexRouteObject } from "react-router";
import { getResourcePath } from "./constant";
import { ListPage } from "pages/ho-so-vi-pham/list-page";
import { DetailPage } from "pages/ho-so-vi-pham/detail-page";
import { EditPage } from "pages/ho-so-vi-pham/edit-page";
import { CreatePage } from "pages/ho-so-vi-pham/create-page";

export const hoSoViPhamRouters: NonIndexRouteObject[] = [
  {
    path: getResourcePath("ho-so-vi-pham", "list"),
    element: (
      <AppLayout>
        <ListPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("ho-so-vi-pham", "detail"),
    element: (
      <AppLayout>
        <DetailPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("ho-so-vi-pham", "edit"),
    element: (
      <AppLayout>
        <EditPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("ho-so-vi-pham", "create"),
    element: (
      <AppLayout>
        <CreatePage />
      </AppLayout>
    ),
  },
];
